module.exports = __webpack_public_path__ + "img/banner1.c7913648.jpg";